module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightrain-64fcb946e2c46c7325b282079f9242dd.svg";